// extracted by mini-css-extract-plugin
export default {"container":"moduleEmptyScreen_container__+5v8p","description":"moduleEmptyScreen_description__OkjX4"};